import React, { Component } from 'react';
import SelectInput from '../selectInput';
import ReactGA from 'react-ga';
import { translate } from 'react-i18next';

class OtherApplication extends Component {
  constructor(props) {
    super(props);

    const applications = this.props.application.applications;
    let options = [];
    let title = '';
    let selected = null;

    if (applications.length > 1) {
      if (applications[0].c_option_display) {
        title = applications[0].c_option_display;
      } else {
        title = applications[0].name;
      }

      applications.map((element) => {
        const option = element.c_option || element.display_name;
        return options.push({
          value: option,
          label: option,
        });
      });
    }

    this.state = {
      selected,
      options,
      title,
      showContent: true,
      expandedProduct: null,
      expandedDescriptions: {},
      showAllProducts: false,
      modalProduct: null,
    };
  }

  getProductData = (gpn) => {
    const { equipment } = this.props;
    return equipment.products.find((product) => product.gpn === gpn);
  }

  toggleRetailerDropdown = (gpn) => {
    this.setState(prevState => ({
      expandedProduct: prevState.expandedProduct === gpn ? null : gpn
    }));
  }

  toggleDescription = (gpn) => {
    this.setState(prevState => ({
      expandedDescriptions: {
        ...prevState.expandedDescriptions,
        [gpn]: !prevState.expandedDescriptions[gpn]
      }
    }));
  }

  openModal = (product) => {
    this.setState({ modalProduct: product });
    document.body.style.overflow = 'hidden';
  }

  closeModal = () => {
    this.setState({ modalProduct: null });
    document.body.style.overflow = 'unset';
  }

  toggleShowAllProducts = () => {
    this.setState(prevState => ({
      showAllProducts: !prevState.showAllProducts
    }));
  }

  // Strip HTML tags from text
  stripHtmlTags = (html) => {
    if (!html) return '';
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  // return the change intervals for the engine
  getOCI = (app) => {
    let text = '';
    const { t, equipment } = this.props;

    return equipment.change_interval
      .filter((i) => Number(i.application_id) === app.id)
      .map((x) => {
        if (x.intervals.length === 1) {
          text = x.intervals[0].value + x.intervals[0].unit;
        } else {
          text =
            x.intervals[0].value +
            x.intervals[0].unit +
            ' / ' +
            x.intervals[1].value +
            x.intervals[1].unit;
        }

        return (
          <p className="oci" key={x.application_id}>
            <span className="title">{t('vehicle_spec.oci')}</span>
            <span>{text}</span>
          </p>
        );
      });
  };

  // change transmission selection
  handleChange = (selected) => {
    this.setState({ selected: selected.value });
  };

  getProductCount = (app) => {
    return (app && app.products && app.products.length) || 0;
  };

  // Create select if multiple engine transmissions
  getSelectInput = (title, options) => {
    let selectedIndex = options.findIndex((element) => element.value === this.state.selected);
    const selected = options[selectedIndex];

    ReactGA.event({
      category: this.props.selectedFamily,
      action: 'Results',
      label: 'Engine Selection',
    });

    return (
      <SelectInput
        key={options.value}
        title={title}
        value={selected}
        simpleValue={true}
        handleChange={this.handleChange}
        options={options}
      />
    );
  };

  renderModal = () => {
    const { modalProduct } = this.state;

    if (!modalProduct) return null;

    return (
      <div className="product-modal-overlay" onClick={this.closeModal}>
        <div className="product-modal" onClick={(e) => e.stopPropagation()}>
          <button className="product-modal__close" onClick={this.closeModal}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <div className="product-modal__content">
            <div className="product-modal__image">
              <img src={modalProduct.image} alt={modalProduct.name} />
            </div>
            <div className="product-modal__text">
              <h3 className="product-modal__title">{modalProduct.name}</h3>
              <p className="product-modal__description">{modalProduct.description}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { t, application, equipment, i18n, selectedFamily, showProductLinks } = this.props;
    const { title, selected, options } = this.state;
    const { parse } = require('qs');
    const query = parse(window.location.search.replace('?', ''));
    const showBuyNow =
      query.buy !== 'false' && i18n.language !== 'fi' && i18n.language !== 'is' && showProductLinks;

    if (options.length && !selected) {
      const firstApp = application.applications[0];
      const count = this.getProductCount(firstApp);
      const hasContent = count > 0 || (firstApp?.note_refs && firstApp.note_refs.length > 0);
      return (
        <>
          <section className="other">
            <div
              className={!hasContent ? 'tab-name no-products no-selection' : `tab-name ${this.state.showContent ? 'active' : ''} no-selection`}
              onClick={hasContent ? () => this.setState({ showContent: !this.state.showContent }) : undefined}
            >
              <span>
                {application.applications[0].name}
              </span>
              <span className="application-count"><span>{count}</span></span>
              {options.length ? (
                <div className="other__filters" onClick={(e) => e.stopPropagation()}>
                  {this.getSelectInput(title, options)}
                </div>
              ) : ''}
            </div>
          </section>
          {this.renderModal()}
        </>
      );
    }

    return (
      <>
        {application.applications.map((app) => {
          if (
            app.c_option === this.state.selected ||
            app.display_name === this.state.selected ||
            this.props.application.applications.length === 1
          ) {
            const count = this.getProductCount(app);
            const hasContent = count > 0 || (app.note_refs && app.note_refs.length > 0);
            return (
              <section className="other" key={app.name}>
                <div
                  className={!hasContent ? 'tab-name no-products' : (this.state.showContent ? 'tab-name active' : 'tab-name')}
                  onClick={hasContent ? () => this.setState({ showContent: !this.state.showContent }) : undefined}
                >
                  <span>
                    {app.name}
                  </span>
                  <span className="application-count"><span>{count}</span></span>
                  {options.length ? (
                    <div className="other__filters" onClick={(e) => e.stopPropagation()}>
                      {this.getSelectInput(title, options)}
                    </div>
                  ) : ''}
                </div>
                {(app.capacity || equipment.change_interval) && (
                  <div className="subtitle-section">
                    <div className="specification-group">
                      {app.capacity && (
                        <div className="spec-item capacity-item">
                          <svg className="spec-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.75">
                              <path d="M13.4062 6.15723L7.62598 10.7812C7.58022 10.8187 7.5309 10.8517 7.47949 10.8809C6.38752 11.4739 6.00098 12.029 6.00098 13V22H19.001V6H21.001V22C21.001 22.5303 20.79 23.039 20.415 23.4141C20.0401 23.789 19.5313 23.9999 19.001 24H6.00098C5.47054 24 4.96101 23.7891 4.58594 23.4141C4.21105 23.039 4.00098 22.5303 4.00098 22V13C3.98939 12.1923 4.2145 11.3991 4.64844 10.7178C5.08233 10.0366 5.70568 9.49699 6.44238 9.16602L12.1562 4.59473L13.4062 6.15723ZM13 11.0234C13.1554 11.0235 13.3092 11.0586 13.4492 11.126C13.5891 11.1934 13.7117 11.2918 13.8086 11.4131C14.3226 12.1211 16 14.546 16 16C16.0232 16.4 15.9618 16.8004 15.8193 17.1748C15.6768 17.5493 15.4562 17.8895 15.1729 18.1729C14.8895 18.4562 14.5493 18.6768 14.1748 18.8193C13.8004 18.9618 13.3999 19.0232 13 19C12.6 19.0232 12.1996 18.9618 11.8252 18.8193C11.4507 18.6768 11.1105 18.4562 10.8271 18.1729C10.5438 17.8895 10.3232 17.5493 10.1807 17.1748C10.0382 16.8004 9.97676 16.3999 10 16C10 14.546 11.6774 12.1211 12.1904 11.4131C12.2875 11.2916 12.4107 11.1934 12.5508 11.126C12.6908 11.0586 12.8446 11.0234 13 11.0234ZM13 13.8076C12.5335 14.4699 12.1944 15.2136 12 16C12 16.691 12.3091 17 13 17C13.691 17 14 16.691 14 16C13.8056 15.2136 13.4665 14.4699 13 13.8076ZM19 0C19.5304 0 20.039 0.210919 20.4141 0.585938C20.7891 0.96101 21 1.46957 21 2V4C21 4.26522 20.8946 4.5195 20.707 4.70703C20.5195 4.89451 20.2652 5 20 5H14C13.7348 4.99995 13.4805 4.89453 13.293 4.70703C13.1055 4.5195 13 4.26518 13 4V2C13 0.700052 14.5461 5.57048e-05 16 0H19ZM16 2C15.6537 1.99494 15.311 2.07132 15 2.22363V3H19V2H16Z" fill="#202020" />
                            </g>
                          </svg>
                          <span className="spec-text">
                            <span className="spec-label">{t('vehicle_spec.capacity')}&nbsp;</span>
                            <span className="spec-value">{app.capacity + ' ' + equipment.model.capacity_unit}</span>
                          </span>
                        </div>
                      )}
                      {equipment.change_interval && equipment.change_interval
                        .filter((i) => Number(i.application_id) === app.id)
                        .map((x) => {
                          let text = '';
                          if (x.intervals.length === 1) {
                            text = x.intervals[0].value + x.intervals[0].unit;
                          } else {
                            text = x.intervals[0].value + x.intervals[0].unit + ' / ' + x.intervals[1].value + x.intervals[1].unit;
                          }
                          return (
                            <div className="spec-item oil-drain-item" key={x.application_id}>
                              <svg className="spec-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.75">
                                  <path fillRule="evenodd" clipRule="evenodd" d="M9.65927 0.230556C11.9868 -0.232361 14.3994 0.00512056 16.5919 0.913173C18.7845 1.8214 20.6591 3.35978 21.9776 5.3331C23.2962 7.30648 24 9.62671 24 12.0001C23.9966 15.1816 22.7312 18.2318 20.4815 20.4815C18.2318 22.7312 15.1816 23.9966 12 24.0001C9.62671 24.0001 7.30648 23.2962 5.3331 21.9776C3.35978 20.6591 1.8214 18.7845 0.913173 16.5919C0.00512056 14.3994 -0.232361 11.9868 0.230556 9.65927C0.693579 7.33149 1.83651 5.19297 3.51474 3.51474C5.19297 1.83651 7.33149 0.693579 9.65927 0.230556ZM12 2.00009C10.0221 2.00009 8.08876 2.58682 6.44429 3.68563C4.79981 4.78442 3.51808 6.34576 2.76118 8.17294C2.00428 10.0002 1.80692 12.0114 2.19215 13.9513C2.57738 15.891 3.52986 17.6729 4.92883 19.0714C6.32779 20.4698 8.10937 21.4218 10.0493 21.8077C11.9893 22.1936 13.9995 21.9962 15.8267 21.2393C17.6539 20.4825 19.2155 19.2002 20.3143 17.5558C21.4131 15.9113 22 13.9779 22 12.0001C21.9966 9.34882 20.9417 6.80744 19.0669 4.9327C17.1922 3.05797 14.6509 2.003 12 2.00009ZM13 12.586L16.4142 16.0001L15 17.4142L11.2929 13.7071C11.1054 13.5196 11 13.2653 11 13.0001V5.00009H13V12.586Z" fill="#202020" />
                                </g>
                              </svg>
                              <span className="spec-text">
                                <span className="spec-label">{t('vehicle_spec.oci')}&nbsp;</span>
                                <span className="spec-value">{text}</span>
                              </span>
                            </div>
                          );
                        })}

                    </div>
                  </div>
                )}
                {(count > 0 || (app.note_refs && app.note_refs.length > 0)) && (
                  <div className={this.state.showContent ? 'content' : 'content hidden'}>
                    {count > 0 && app.products && (
                      <div className="products-grid">
                        {(this.state.showAllProducts ? app.products : app.products.slice(0, 3)).map((product, i) => {
                          const productData = this.getProductData(product.gpn);
                          if (!productData) {
                            // Fallback for products without full data - still use card layout
                            const defaultImage = (equipment && equipment.default_image_url) || '/images/product_default.png';
                            return (
                              <div key={product.name || i} className="product-card">
                                <div className="product-card__image">
                                  <img src={defaultImage} alt={product.name} />
                                </div>

                                <div className="product-card__description">
                                  <div className="product-card__content">
                                    <div className="product-card__header">
                                      <h3 className="product-card__title">{product.name}</h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }

                          const details = productData.product_page_link || null;
                          const preferredPac = (productData.pacs && productData.pacs.find((pac) => pac.volume === '4L')) || null;
                          const fallbackPac = productData.pacs && productData.pacs[0];
                          const pacShot = (preferredPac && preferredPac.img) || (fallbackPac && fallbackPac.img) || productData.default_image_url || (equipment && equipment.default_image_url) || '/images/product_default.png';
                          const description = this.stripHtmlTags(productData.short_description) || '';
                          const isExpanded = this.state.expandedDescriptions[product.gpn];
                          const isDropdownOpen = this.state.expandedProduct === product.gpn;
                          const maxDescriptionLength = 200;
                          const needsReadMore = description.length > maxDescriptionLength;
                          const displayDescription = (isExpanded || !needsReadMore) ? description : description.substring(0, maxDescriptionLength) + '...';

                          return (
                            <div key={product.gpn} className="product-card">
                              <div className="product-card__image">
                                <img src={pacShot} alt={productData.name} />
                              </div>

                              <div className="product-card__description">
                                <div className="product-card__content">
                                  <div className="product-card__header">
                                    <h3 className="product-card__title">{productData.name}</h3>
                                  </div>

                                  {description && (
                                    <div className="product-card__text">
                                      <p>{displayDescription}</p>
                                      {needsReadMore && (
                                        <button
                                          className="read-more-link"
                                          onClick={() => this.openModal({ gpn: product.gpn, name: productData.name, image: pacShot, description: description })}
                                        >
                                          {t('result_page.read_more')}
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </div>

                                <div className="product-card__cta-group">
                                  {details && showProductLinks && query.details !== 'false' && (
                                    <a
                                      className="button button--primary"
                                      href={details}
                                      target="_blank"
                                      onClick={() => {
                                        ReactGA.event({
                                          category: i18n.language,
                                          action: selectedFamily,
                                          label: productData.name + ' Details',
                                        });
                                      }}
                                    >
                                      {t('result_page.product_details')}
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.34155 4.33233C8.23332 4.43858 8.14742 4.56498 8.0888 4.70425C8.03018 4.84351 8 4.99289 8 5.14376C8 5.29463 8.03018 5.44401 8.0888 5.58328C8.14742 5.72255 8.23332 5.84895 8.34155 5.95519L14.2419 11.7952C14.2698 11.8218 14.292 11.8538 14.3072 11.8891C14.3224 11.9245 14.3302 11.9625 14.3302 12.0009C14.3302 12.0393 14.3224 12.0773 14.3072 12.1127C14.292 12.148 14.2698 12.18 14.2419 12.2066L8.34155 18.0466C8.23332 18.1529 8.14742 18.2793 8.0888 18.4185C8.03018 18.5578 8 18.7072 8 18.858C8 19.0089 8.03018 19.1583 8.0888 19.2976C8.14742 19.4368 8.23332 19.5632 8.34155 19.6695C8.55789 19.8823 8.85054 20.0018 9.15559 20.0018C9.46063 20.0018 9.75328 19.8823 9.96962 19.6695L16.4935 13.2123C16.8178 12.8909 17 12.4552 17 12.0009C17 11.5466 16.8178 11.1109 16.4935 10.7895L9.96962 4.33233C9.75328 4.11948 9.46063 4 9.15559 4C8.85054 4 8.55789 4.11948 8.34155 4.33233Z" fill="white" />
                                      </svg>
                                    </a>
                                  )}

                                  {showBuyNow && productData.links && productData.links.length > 0 ? (
                                    <div
                                      className="ecommerce-button"
                                      onMouseLeave={() => this.setState({ expandedProduct: null })}
                                    >
                                      <button
                                        className="button button--outline"
                                        onClick={() => this.toggleRetailerDropdown(product.gpn)}
                                      >
                                        <span>{t('result_page.buy_online')}</span>
                                        <svg className="caret-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M2.78579 4H13.2142C13.3573 4.00001 13.4976 4.034 13.6201 4.0983C13.7426 4.1626 13.8426 4.25478 13.9093 4.36488C13.976 4.47499 14.0069 4.59886 13.9987 4.72312C13.9905 4.84738 13.9434 4.96733 13.8625 5.07003L8.64834 11.7022C8.5762 11.794 8.47941 11.8691 8.36636 11.921C8.25332 11.9729 8.12743 12 7.99961 12C7.87179 12 7.7459 11.9729 7.63285 11.921C7.51981 11.8691 7.42302 11.794 7.35088 11.7022L2.13745 5.07003C2.05662 4.96733 2.00955 4.84738 2.00131 4.72312C1.99306 4.59886 2.02396 4.47499 2.09068 4.36488C2.15739 4.25478 2.25739 4.1626 2.37989 4.0983C2.50238 4.034 2.64273 4.00001 2.78579 4Z" fill="#0C479D" />
                                        </svg>
                                      </button>

                                      {isDropdownOpen && (
                                        <div className="ecommerce-dropdown">
                                          {productData.links.map((link, index) => (
                                            <a
                                              key={index}
                                              href={link.url}
                                              target="_blank"
                                              className="ecommerce-dropdown__option"
                                              onClick={() => {
                                                ReactGA.event({
                                                  category: i18n.language,
                                                  action: selectedFamily,
                                                  label: `${productData.name} - ${link.supplier}`,
                                                });
                                              }}
                                            >
                                              <img src={link.img} alt={link.supplier} className="ecommerce-dropdown__image" />
                                            </a>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="ecommerce-button" style={{ visibility: 'hidden' }}>
                                      <button className="button button--outline">
                                        <span>{t('result_page.buy_online')}</span>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        {!this.state.showAllProducts && app.products.length > 3 && (
                          <div className="show-more-products-item">
                            <button
                              className="show-more-products-link"
                              onClick={this.toggleShowAllProducts}
                            >
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 19L3 10.0753L5.09286 8L12 14.8493L18.9071 8L21 10.0753L12 19Z" fill="#0C479D" />
                              </svg>
                              {t('result_page.show_more_products')}
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                    {app.note_refs && app.note_refs.length > 0 && (
                      <div className="section-notes">
                        <span className="section-notes__title">{t('result_notes.notes')}</span>
                        <div className="section-notes__list">
                          {app.note_refs.map((ref) => {
                            const note = equipment.application_notes.find(
                              (n) => n.note_index === ref.note_index
                            );
                            return note ? (
                              <div key={note.id} className="section-notes__item">
                                <span className="note-text">{note.text}</span>
                              </div>
                            ) : null;
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </section>
            );
          } else {
            return false;
          }
        })}
        {this.renderModal()}
      </>
    );
  }
}

export default translate('translations')(OtherApplication);
